var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportToPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 0v4c0 .733.6 1.333 1.37 1.333H12V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h4.667zM5.166 1.5H2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6.833H8.038c-1.53 0-2.78-1.17-2.866-2.666L5.167 4l-.001-2.5zM3.324 10c.263 0 .49.053.683.158.193.104.342.255.447.45.084.156.134.333.151.533l.006.153V10h1.397c.324 0 .61.072.861.215.25.143.445.347.583.61.07.134.122.28.157.437L7.606 10H10v.765H8.47v.77h1.347v.765H8.469v1.2h-.863l.003-1.262a1.74 1.74 0 0 1-.157.437 1.474 1.474 0 0 1-.583.61c-.25.143-.537.215-.86.215H4.611l-.001-2.205-.006.154c-.017.2-.067.376-.15.531a1.091 1.091 0 0 1-.448.448c-.193.105-.42.157-.683.157H2.82v.915H2V10h1.324zm2.65.79h-.527v1.92h.528a.781.781 0 0 0 .61-.255c.153-.17.23-.405.23-.705 0-.3-.077-.535-.23-.705a.781.781 0 0 0-.61-.255zm-2.7-.01H2.82v1.025h.456c.168 0 .295-.044.38-.132.086-.089.129-.215.129-.378s-.043-.29-.129-.38c-.085-.09-.212-.135-.38-.135zM8.075.427a.25.25 0 0 1 .353 0l3.146 3.146a.25.25 0 0 1-.177.427H8.25A.25.25 0 0 1 8 3.75V.604a.25.25 0 0 1 .073-.177z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportToPdf);
export default __webpack_public_path__ + "static/media/export-to-pdf.2076beadb9481e9e43b0b4562520ce9d.svg";
export { ForwardRef as ReactComponent };